import * as React from 'react'
import Model from './Model'

export const ModelContext = React.createContext<Model>(null)

export const FirebaseContext = React.createContext(null)



// WEBPACK FOOTER //
// ./src/Ctx.tsx